import { Component, Vue } from "vue-property-decorator";
import { ValidateIf, IsDefined, IsNotEmpty, MaxLength, validate } from "class-validator";

import { SideNav } from "@/layout";
import { Lightbox } from "@/components";
import { ErrorCode, ErrorMessage } from "@/constant";
import { QuizModel } from "@/models";
import { Common } from "../Common";

export class QuestionForm {
    @IsDefined() @IsNotEmpty({ message: "必填" }) grade = "";
    @IsDefined() @IsNotEmpty({ message: "必填" }) level = "";
    @IsDefined() @IsNotEmpty({ message: "必填" }) unit = "";
    @IsDefined() @IsNotEmpty({ message: "必填" }) difficulty = "";
    @IsDefined() @IsNotEmpty({ message: "必填" }) tid = "";
    @IsDefined() @IsNotEmpty({ message: "必填" }) type = "1";
    @IsDefined() @IsNotEmpty({ message: "必填" }) @MaxLength(1000, { message: "最多輸入1000字" }) question = '';
    audio = '';
    pic = ''; //圖片需有初始值
    @ValidateIf(o => o.type === '1') @IsNotEmpty({ message: "必填" }) type1 = '1';
    @ValidateIf(o => o.type === '1' && o.type1 === '1') @IsNotEmpty({ message: "必填" }) pic1 = '';
    @ValidateIf(o => o.type === '1' && o.type1 === '2') @IsNotEmpty({ message: "必填" }) text1 = '';
    @ValidateIf(o => o.type === '1') @IsNotEmpty({ message: "必填" }) type2 = '1';
    @ValidateIf(o => o.type === '1' && o.type2 === '1') @IsNotEmpty({ message: "必填" }) pic2 = '';
    @ValidateIf(o => o.type === '1' && o.type2 === '2') @IsNotEmpty({ message: "必填" }) text2 = '';
    type3 = '1';
    pic3 = '';
    text3 = '';
    type4 = '1';
    pic4 = '';
    text4 = '';
    type5 = '1';
    pic5 = '';
    text5 = '';
    @ValidateIf(o => o.type === '2') @IsNotEmpty({ message: "必填" }) option1 = '';
    @ValidateIf(o => o.type === '2') @IsNotEmpty({ message: "必填" }) option2 = '';
    @IsDefined() @MaxLength(500, { message: "最多輸入500字" }) suggestAns = '';
    @ValidateIf(o => o.type === '1' || o.type === '2') @IsNotEmpty({ message: "必填" }) answer = '';
    @IsDefined() @IsNotEmpty({ message: "必填" }) active = "1";
}

type response = { [key: string]: unknown };

@Component<AdminQuizQuestionAddController>({
    components: {
        SideNav, Lightbox
    }
})
export default class AdminQuizQuestionAddController extends Vue {
    /*定義data 變數 */
    private doubleClick = false;
    private questionForm = new QuestionForm();
    private teacherList: object = {};
    private gradeList: object = {};
    private levelList: object = {};
    private unitList: response = {};
    private token = window.localStorage.getItem('adminToken') as string;

    private errorMsg = "";
    private openLB = false;
    private errNo = 0;

    private errorMsgMap: { [key: string]: string } = {
        grade: '',
        unit: '',
        level: '',
        difficulty: '',
        tid: '',
        type: '',
        question: '',
        type1: '',
        pic1: '',
        text1: '',
        type2: '',
        pic2: '',
        text2: '',
        type3: '',
        pic3: '',
        text3: '',
        type4: '',
        pic4: '',
        text4: '',
        type5: '',
        pic5: '',
        text5: '',
        option1: '',
        option2: '',
        answer: '',
        suggestAns: '',
        active: '',
    };

    public async created() {
        this.getTeacher();
        this.gradeList = await Common.getGrade();
    }

    private async getLevel() {
        this.questionForm.level = '';
        this.questionForm.unit = '';    
        const grade = this.questionForm.grade;
        this.levelList = await Common.getLevel(grade);
        this.unitList = {};
    }

    private async getUnit() {
        this.questionForm.unit = '';
        this.unitList = await Common.getUnit();
    }

    // 依照登入者身分列出可選老師
    private async getTeacher() {
        const identity = window.localStorage.getItem('admin_identity') as string;
        const sid = window.localStorage.getItem('admin_sid') as string;

        const item: { type: number, identity: string, sid: string, token: string } = {
            type: 1, //取active = 1
            identity: identity,
            sid: sid,
            token: this.token,
        }
        const data = await QuizModel.getTeacher(item) as response;
        Common.checkToken(data.ERR_CODE as number);
        this.teacherList = data.list as object;
    }

    private previewfile(event: any) {
        const file = event.target.files[0];

        if (file) { //若有上傳
            /* 限制檔案上傳型別 */
            const suffixName = file.name.substring(file.name.lastIndexOf('.') + 1);   // 得到檔案字尾名
            if (suffixName !== 'mp3') {
                this.errorMsg = '上傳檔案只能是 mp3 格式！';
                this.openLB = true;
                return;
            }
            /* 限制檔案上傳大小 */
            const isLimitSize = file.size / 1024 / 1024 < 5;
            if (!isLimitSize) {
                this.errorMsg = '上傳檔案不能超過 5MB！';
                this.openLB = true;
                return;
            }
            const reader = new FileReader();

            reader.onload = (e: any) => {
                this.questionForm.audio = file.name;
            };
            reader.readAsDataURL(file);
        }
    }

    private previewPic(event: any, name: number) {
        const file = event.target.files[0];

        if (file) { //若有上傳圖片
            /* 限制檔案上傳型別 */
            const suffixName = file.name.substring(file.name.lastIndexOf('.') + 1);   // 得到檔案字尾名
            if (suffixName !== 'jpg' && suffixName !== 'png' && suffixName !== 'gif' && suffixName !== 'jpeg') {
                this.errorMsg = '上傳檔案只能是 jpg、png、gif、jpeg 格式！';
                this.openLB = true;
                return;
            }
            /* 限制檔案上傳大小 */
            const isLimitSize = file.size / 1024 / 1024 < 3;
            if (!isLimitSize) {
                this.errorMsg = '上傳檔案不能超過 3MB！';
                this.openLB = true;
                return;
            }
            const reader = new FileReader();

            reader.onload = (e: any) => {
                switch (name) {
                    case 1:
                        this.questionForm.pic1 = e.target.result;
                        break;
                    case 2:
                        this.questionForm.pic2 = e.target.result;
                        break;
                    case 3:
                        this.questionForm.pic3 = e.target.result;
                        break;
                    case 4:
                        this.questionForm.pic4 = e.target.result;
                        break;
                    case 5:
                        this.questionForm.pic5 = e.target.result;
                        break;
                    default:
                        this.questionForm.pic = e.target.result;
                        break;
                }
            };
            reader.readAsDataURL(file);
        }
    }

    private delPic() {
        this.questionForm.pic = '';
    }

    private validateAndSubmit() {
        validate(this.questionForm, { skipMissingProperties: true }).then(
            async result => {
                if (result.length !== 0) {
                    this.errorMsgMap = { //先清空error message
                        grade: '',
                        unit: '',
                        level: '',
                        difficulty: '',
                        tid: '',
                        type: '',
                        question: '',
                        type1: '',
                        pic1: '',
                        text1: '',
                        type2: '',
                        pic2: '',
                        text2: '',
                        type3: '',
                        pic3: '',
                        text3: '',
                        type4: '',
                        pic4: '',
                        text4: '',
                        type5: '',
                        pic5: '',
                        text5: '',
                        option1: '',
                        option2: '',
                        suggestAns: '',
                        answer: '',
                        active: '',
                    };
                    result.forEach((item, index) => {
                        const error = item.constraints as {
                            [key: string]: string;
                        };
                        Object.keys(error).forEach(key => {
                            this.errorMsgMap[item.property] = error[key]; //放入error message
                        });
                    });
                    return;
                }

                if (!this.doubleClick) {
                    this.doubleClick = true;

                    const formobj: HTMLFormElement = document.getElementById('questionAdd') as HTMLFormElement;
                    const data = new FormData(formobj); //創建空的Formdata object

                    data.append('token', this.token);

                    this.errNo = await QuizModel.addQuestion(data);
                    Common.checkToken(this.errNo);
                    this.openLB = true;
                    this.doubleClick = false;
                    this.errorMsg = ErrorMessage[this.errNo];
                }
            }
        )
    }

    private closeLB() {
        this.openLB = false;
        if (this.errNo === ErrorCode.Success) {
            this.$router.push("/admin/quiz/question");
        }
    }
}
